const toCamelCase = function (string) {
  return string.replace(/\b(\w)/g, function (match, capture) {
    return capture.toUpperCase();
  }).replace(/\s+/g, '');
};

export default toCamelCase;
